"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useOnDismiss = (ref, onDismiss) => {
    (0, react_1.useEffect)(() => {
        const current = ref.current;
        onDismiss && (current === null || current === void 0 ? void 0 : current.addEventListener('dismiss', onDismiss));
        return () => {
            onDismiss && (current === null || current === void 0 ? void 0 : current.removeEventListener('dismiss', onDismiss));
        };
    });
};
exports.default = useOnDismiss;
